import { render, staticRenderFns } from "./WelcomeActivity.vue?vue&type=template&id=0a2aef00&scoped=true&"
import script from "./WelcomeActivity.vue?vue&type=script&lang=js&"
export * from "./WelcomeActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=0a2aef00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2aef00",
  null
  
)

export default component.exports